<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import request from "@/utils/axios.js";

    export default {
        name: "SiteInfo",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'name',
                        placeholder: '名称',
                        type: 'input'
                    },
                    {
                        name: 'status',
                        placeholder: '状态',
                        type: 'select',
                        selectValue: [{
                            key: 1,
                            value: '启用'
                            },{
                                key: 0,
                                value: '禁用'
                            }]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'siteInfo:add',
                    update: 'siteInfo:update',
                    delete: 'siteInfo:delete',
                    deleteBatch: 'siteInfo:deleteBatch'
                },
                url: {
                    get: '/siteInfo/listByCondition',
                    add: '/siteInfo/add',
                    update: '/siteInfo/update',
                    //delete: '/siteInfo/delete/',
                    //delete_batch: '/siteInfo/deleteBatch',
                    status: '/siteInfo/status',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                },{
                    field: 'name',
                    label: '名称',
                    show: true,
                    width: '',
                }, {
                    field: 'pid',
                    label: 'PID',
                    show: true,
                    width: '',
                }, {
                    field: 'secret',
                    label: '秘钥',
                    show: true,
                    width: '',
                }, {
                    field: 'ipWhite',
                    label: 'IP白名单',
                    show: true,
                    width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }, {
                    field: 'status',
                    label: '状态',
                    show: true,
                    status: true,
                    width: '',
                }],
                operate: [{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '重置秘钥',
                    handle: (row) => {
                        request.post({
                            url: '/siteInfo/reset/' + row.id,
                            data: {},
                            confirm: '确定重置该秘钥？',
                            success: (res) => {
                                if(res.code === 0){
                                    this.$message.success('秘钥重置成功');
                                    this.$refs.table.getData();
                                }else{
                                    this.$message.error(res.msg || '秘钥重置失败');
                                }
                            }
                        });
                    }
                }],
                formFields: {
                    addTitle: '添加网站信息',
                    updateTitle: '修改网站信息',
                    model: [{
                        field: 'name',
                        label: '名称：',
                        type: 'input',
                        placeholder: '名称',
                        rules:[{message: '请输入名称', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'ipWhite',
                        label: 'IP白名单：',
                        type: 'input',
                        placeholder: 'IP白名单',
                        rules:[],
                        add: true,
                        update: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
